export const COURSE_PAUSE_REQUEST_TYPE_OPTIONS = [
  {
    label: 'Pause Requests',
    value: '/course-pause/future-dated/to-be-resumed',
  },
  {
    label: 'Reset Requests',
    value: '/course-pause/back-dated/to-be-resumed',
  },
];
